import React from "react";

/**
 * Horizontal segmented score bar — replaces ring gauges.
 * 20-segment indicator like a Bloomberg risk meter / credit score.
 */
export default function ScoreBar({ value = 0, label, className = "", showValue = true }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const lit = Math.round((v / 100) * 20);
  const tone = v >= 75 ? "green" : v >= 50 ? "amber" : "red";
  const valueColor = v >= 75 ? "text-signal" : v >= 50 ? "text-gold" : "text-alert";
  return (
    <div className={className}>
      {(label || showValue) && (
        <div className="flex items-baseline justify-between mb-2">
          {label && <span className="label-mono">{label}</span>}
          {showValue && (
            <span className={`font-mono tabular font-medium ${valueColor}`}>
              {v}<span className="text-ink/30">/100</span>
            </span>
          )}
        </div>
      )}
      <div className={`score-bar ${tone}`} aria-hidden>
        {/* 20 static decorative segments — order is fixed by index, never reorders. */}
        {Array.from({ length: 20 }).map((_, i) => (
          <span key={`seg-${i}`} className={`seg ${i < lit ? "on" : ""}`} />
        ))}
      </div>
    </div>
  );
}
